export function ENVDefaultObj() {
  this['env'] = {
    selectorId        : '',
    optionHeadVisible : true,
    optionHeadArr     : [],
    optionBodyArr     : [],
    placeholder       : '',
    noDataMessage     : 'No data avaliable',
    indexAttribute    : '',
    styleObj          : {},
    printoutFn        : function() {},
    refFn             : function() {},
    addtionalButton   : {
      enable       : true,
      selectButton : 'Select',
      searchButton : 'Search',
      clearButton  : 'Clear'
    },
    featureSearch : {
      enable                    : false,
      searchSpecAttributeEnable : false,
      searchSpecAttributeArr    : []
    }
  };
}

export function POInfoObj (id) {
  this['printout'] = {
    selectorId     : id,
    selectedOption : {},
    inputValue     : ''
  };
}

export function optionHeadObj (source) {
  this['name'] = '';
  this['index'] = '';
  Object.keys(source).map((key) => {
    this[key] = source[key];
  });
}

export function nodeObj (env, name) {
  this['props'] = {
    key       : name, 
    className : name,
    style     : (env.styleObj[name])? Object.assign({}, env.styleObj[name]) : {}
  };
}
